import { render, staticRenderFns } from "./auditConfiguration.vue?vue&type=template&id=966c9292&scoped=true&"
import script from "./auditConfiguration.vue?vue&type=script&lang=js&"
export * from "./auditConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966c9292",
  null
  
)

component.options.__file = "auditConfiguration.vue"
export default component.exports